// This composable is usually extended by the layer
// eg. useCareersGlobalData

type GlobalContentData = Partial<{
  dataCookie: Record<string, string | object>
  image: string
  labels: Record<string, string>
  search: Record<string, string>
  careerLabels: Record<string, any>
  formLabels: Record<string, any>
  filterLabels: Record<string, any>
  investorLabels: Record<string, any>
  partnerLabels: Record<string, any>
  legalLabels: Record<string, any>
  charityLabels: Record<string, any>
  knowledgeHubLabels: Record<string, any>
  globalDataProductLabels: Record<string, any>
  paymentMethodsLabels: Record<string, any>
  paymentsLabels: Record<string, any>
  paymentCountryLabels: Record<string, any>
  eventsLabels: Record<string, any>
}>

const apiEndpoints = new Map([
  ['min', '/api/v3/core_data/min'],
  ['filter-labels', '/api/v3/core_data/filter-labels'],
  ['investor-relations-labels', '/api/v3/core_data/investor-relations-labels'],
  ['global-product', '/api/v3/core_data/global-product'],
  ['form-labels', '/api/v3/core_data/form-labels'],
  ['global-forms', '/api/v3/core_data/global-forms'],
  ['global-industry', '/api/v3/core_data/global-industry'],
  ['global-offices', '/api/v3/core_data/global-offices'],
  ['global-business-type', '/api/v3/core_data/global-business-type']
])

const baseCategories = ['min', 'navigation']

export const useGlobalData = () => {
  const runtimeConfig = useRuntimeConfig()
  const targetSite = runtimeConfig.public.targetSite
  // const { getLocaleIso } = useLocales()
  const { locale } = useI18n()
  // const localeRef = ref('en') // TODO remove
  // const locale = computed(() => getLocaleIso(localeRef.value)) // TODO: Check if makes sense that it does not apply anymore

  const labels = computed(() => ({
    ...(localeGlobalContentData.value?.labels || {}),
    ...(localeGlobalContentData.value?.careerLabels || {}),
    ...(localeGlobalContentData.value?.formLabels || {}),
    ...(localeGlobalContentData.value?.filterLabels || {}),
    ...(localeGlobalContentData.value?.investorLabels || {}),
    ...(localeGlobalContentData.value?.partnerLabels || {}),
    ...(localeGlobalContentData.value?.legalLabels || {}),
    ...(localeGlobalContentData.value?.charityLabels || {}),

    ...(localeGlobalContentData.value?.knowledgeHubLabels || {}),
    ...(localeGlobalContentData.value?.globalDataProductLabels || {}),
    ...(localeGlobalContentData.value?.paymentMethodsLabels || {}),
    ...(localeGlobalContentData.value?.paymentsLabels || {}),
    ...(localeGlobalContentData.value?.paymentCountryLabels || {}),
    ...(localeGlobalContentData.value?.eventsLabels || {})
  }))

  // const route = useRoute()
  // const preview = useRuntimeConfig().public.preview

  const globalContentData = useState('globalData', () => null)

  const setGlobalContentData = (data: any) => {
    globalContentData.value = data
  }

  const getGlobalCategoryEndpoint = (cat: string) => {
    return apiEndpoints.get(cat)
  }

  const localeGlobalContentData: ComputedRef<GlobalContentData> = computed(
    () => globalContentData.value?.[locale.value] || {}
  )

  const generateDataPromisesForContentType = (
    contentType: string,
    specificCategoriesMap: Map<string, string[]>,
    specificEndpoints?: Map<string, string>,
    locale?: string
  ) => {
    const specificCategories = specificCategoriesMap.get(contentType)
    const categories = baseCategories.concat(specificCategories || [])

    const promises = categories.map((cat) => {
      if (specificEndpoints?.has(cat)) {
        const endpoint = specificEndpoints.get(cat)!

        if (locale) {
          return $fetch(endpoint + '/' + locale + '?targetSite=' + targetSite)
        }

        return $fetch(endpoint + '?targetSite=' + targetSite)
      }

      const globalEndpoint = getGlobalCategoryEndpoint(cat)
      if (!globalEndpoint) {
        return null
      }

      if (locale) {
        return $fetch(globalEndpoint + '/' + locale + '?targetSite=' + targetSite)
      }

      return $fetch(globalEndpoint + '?targetSite=' + targetSite)
    })
    return promises.filter(Boolean)
  }

  const ogImage = computed(() => localeGlobalContentData.value.image)

  return {
    labels,
    ogImage,
    // baseCategories,
    setGlobalContentData,
    generateDataPromisesForContentType,
    getGlobalCategoryEndpoint,
    globalContentData,
    localeGlobalContentData
  }
}
